<div class="side-nav-section">
  <div class="side-nav-item" *ngIf="!gdoPortalActive">
    <button mat-flat-button [routerLink]="gdoPortalActive ? ['/gdo-product'] : ['/myvehicle']" [routerLinkActive]="'is-active'" [disabled]="gdoPortalActive">
      <span class="red-color">My Vehicle</span>
    </button>
    <div class="buttonBorder"></div>
  </div>

  <!-- My products //shown on GDO-->
<div *ngIf="gdoPortalActive">
  <div class="side-nav-item">
    <button mat-flat-button [routerLink]="['/gdo']" [routerLinkActive]="'is-active'">
      <span class="red-color">My Products</span>
    </button>
    <div class="buttonBorder"></div>
  </div>
</div>
  <!-- <div class="side-nav-item">
    <button mat-flat-button [routerLink]="['/Profile']" [routerLinkActive]="'is-active'">
      <span class="red-color">Profile</span>
    </button>
    <div class="buttonBorder"></div>
  </div> -->

  <!-- As the payment methods are not available then we will not show payment methods -->
  <div class="side-nav-item">
    <button mat-flat-button [routerLink]="gdoPortalActive?['/billing']:['/payment']" [routerLinkActive]="'is-active'" [disabled]="!accountExist">
      <span *ngIf="accountExist" class="red-color">Payment</span>
      <span *ngIf="!accountExist">Payment</span>
    </button>
    <div class="buttonBorder"></div>
  </div>
</div>